import React from 'react';
import BHAFooter from '../../../../components/Footer';

/*
 This component is used for the Quest footer if "showFooter" is set to true
*/
export default () => {
    return <BHAFooter />;
};
